import { MenuItem, SubMenu } from '@szhsin/react-menu';

const ICON_SIZE = {
  small: '15px',
  medium: '20px',
  large: '25px',
};

function _SubMenuItem({ option }) {
  return (
    <SubMenu
      key={option.title}
      disabled={false || option.disabled}
      label={
        <>
          {option.icon && (
            <i
              className={option.icon}
              style={{
                marginRight: '15px',
                fontSize: option.iconSize || ICON_SIZE.medium,
                color: !option.disabled
                  ? option.color
                    ? option.color
                    : '#2f3a3f'
                  : '#AAAAAA',
              }}
            />
          )}
          <div>
            <div>
              <span
                style={{
                  color: !option.disabled
                    ? option.color
                      ? option.color
                      : '#2f3a3f'
                    : '#AAAAAA',
                  fontSize: '15px',
                }}
              >
                {option.title}
              </span>
            </div>
            {option.subtitle && (
              <span
                style={{
                  fontSize: 'small',
                  color: !option.disabled ? '#92929D' : '#AAAAAA',
                }}
              >
                {option.subtitle}
              </span>
            )}
          </div>
        </>
      }
    >
      {option.subMenuOptions.map((subMenuOption) =>
        subMenuOption.subMenuOptions?.length > 0 ? (
          <_SubMenuItem key={subMenuOption.title} option={subMenuOption} />
        ) : (
          <MenuItem
            key={subMenuOption.title}
            onClick={() => subMenuOption.onClick(subMenuOption)}
            disabled={false || subMenuOption.disabled}
          >
            {subMenuOption.icon && (
              <i
                className={subMenuOption.icon}
                style={{
                  marginRight: '15px',
                  fontSize: subMenuOption.iconSize || ICON_SIZE.medium,
                  color: !subMenuOption.disabled
                    ? subMenuOption.color
                      ? subMenuOption.color
                      : '#2f3a3f'
                    : '#AAAAAA',
                }}
              />
            )}
            <div>
              <div>
                <span
                  style={{
                    color: !subMenuOption.disabled
                      ? subMenuOption.color
                        ? subMenuOption.color
                        : '#2f3a3f'
                      : '#AAAAAA',
                    fontSize: '15px',
                  }}
                >
                  {subMenuOption.title}
                </span>
              </div>
              {subMenuOption.subtitle && (
                <span
                  style={{
                    fontSize: 'small',
                    color: !subMenuOption.disabled ? '#92929D' : '#AAAAAA',
                  }}
                >
                  {subMenuOption.subtitle}
                </span>
              )}
            </div>
          </MenuItem>
        ),
      )}
    </SubMenu>
  );
}

export default _SubMenuItem;
